import React from 'react'
import { Container, Header, Button, Icon } from 'semantic-ui-react';
import Link from 'gatsby-link'
import Fade from 'react-reveal/Fade';
import '../styles/travelSection.scss';


const TravelSection = props => (
  <section className="content-deck travel">
    <h1 className="content-deck__headline">Travel</h1>
    <Container >
        <Fade left cascade>

            <div className="travel__items">

                <div className="travel__item">
                <Icon className="travel__item-icon" size="huge" name="hotel" />

                    <div className="travel__item-headline">Hotels</div>
                    <div className="travel__item-description">
All conference events will be held at the Hyatt Regency Greenville.  Find more information about the hotel and how to reserve a room at the special conference rate here.                    </div>
                    <Button floated='left' target="_blank" href="https://book.passkey.com/gt/lodging/215184414?gtid=99f2bf3a665c3fcb8127c7a46a9a2d0e" inverted size='mini' color="black" className="travel__item-button"> Details </Button>
                </div>
                <div className="travel__item">
                <Icon className="travel__item-icon" size="huge" name="plane" />

                    <div className="travel__item-headline">Airport</div>
                    <div className="travel__item-description">
The Greenville-Spartanburg International Airport (GSP) is less than 15 miles from the conference venue.  Find more information about flying to and from this airport here.                    </div>
                        <Button floated='left' target="_blank" href="https://www.gspairport.com/" inverted size='mini' color="black" className="travel__item-button"> Details </Button>
                </div>
                <div className="travel__item">
                <Icon className="travel__item-icon" size="huge" name="car" />

                    <div className="travel__item-headline">Transportation</div>
                    <div className="travel__item-description travel__item-description--last">
                            Getting around Greenville couldn’t be easier!  Find more information about the many ways to traverse the city here.
                    </div>
                    <Button floated='left' inverted size='mini' color="black" className="travel__item-button"> <Link to='transportation'>Details</Link> </Button>
                </div>



            </div>
        </Fade>
    </Container>
  </section>
)

export default TravelSection



// WEBPACK FOOTER //
// ./src/sections/travelSection.js